import { fetcher } from '../../../scripts/utils/fetch.js';
import Urls from './urls.js';

export default class ReviewFeedbackApp {
	constructor({ el }) {
		if (!el) {
			throw new Error('"el" is required!');
		}

		this.el = el;
		this.review_id = this.el.getAttribute('data-review-id');
		this.positive_feedback_btn = this.el.querySelector('.js-btn-review-feedback-positive');
		this.negative_feedback_btn = this.el.querySelector('.js-btn-review-feedback-negative');
		this.flag_btn = this.el.querySelector('.js-btn-review-feedback-flag');
		this.controls = this.el.querySelectorAll('.feedback-control');
		this.positive_count = this.el.querySelector('.js-review-feedback-positive-count');
		this.negative_count = this.el.querySelector('.js-review-feedback-negative-count');

		this.markVoted();
		this.bindEvents();
	}

	bindEvents() {
		this.positive_feedback_btn.addEventListener('click', this.sendPositive.bind(this));
		this.negative_feedback_btn.addEventListener('click', this.sendNegative.bind(this));
		if( this.flag_btn ) {
			this.flag_btn.addEventListener('click', this.sendFlag.bind(this));
		}
	}

	sendPositive(event) {
		const feedback = {
			review_id: this.review_id,
			positive: true
		};

		this.send(feedback, event.currentTarget);
	}

	sendNegative(event) {
		const feedback = {
			review_id: this.review_id,
			negative: true
		};

		this.send(feedback, event.currentTarget);
	}

	sendFlag(event) {
		const feedback = {
			review_id: this.review_id,
			flag: true
		};

		this.send(feedback, event.currentTarget);
	}

	send(feedback, btn) {
		const url = Urls.Api.feedback(this.review_id);

		btn.classList.add('progress');
		fetcher(url, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(feedback)
		})
			.then(response => {
				const comment = response.data;

				this.render(comment);
				btn.classList.add('selected');
				this.saveVoteLocal(comment);
			})
			.finally(() => {
				btn.classList.remove('progress');
			});
	}

	saveVoteLocal(comment) {
		const comment_id = comment.commentid;

		if (!this.isVoted(comment_id)) {
			if (comment_id && window.localStorage) {
				const voted = this.getVotedLocal();

				voted.push(comment_id);
				localStorage.setItem('voted_reviews', JSON.stringify(voted));
			}
		}
	}

	markVoted() {
		if (this.isVoted(this.review_id)) {
			this.controls.forEach(elem => elem.classList.add('voted'));
		}
	}

	isVoted(comment_id) {
		if (comment_id && window.localStorage){
			const voted = this.getVotedLocal();

			return voted && voted.includes(comment_id);
		}

		return false;
	}

	getVotedLocal() {
		if (window.localStorage) {
			const voted = localStorage.getItem('voted_reviews');

			if (voted) {
				return JSON.parse(voted);
			}
		}

		return [];
	}

	render(review) {
		this.controls.forEach(elem => elem.classList.add('voted'));
		this.positive_count.textContent = review.feedback_positive_count || 0;
		this.negative_count.textContent = review.feedback_negative_count || 0;
	}
}